import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import cookies from 'js-cookie';
import { SUPPORT_LOGIN } from '../../api';
import Preloader from '../../components/Preloader/Preloader';

const SupportLoginPage = ({ store }) => {
    const history = useHistory();

    function supportAdmin(login, sessionId) {
        SUPPORT_LOGIN(login, sessionId)
            .then((data) => {
                if (data.success === true) {
                    const user = { isSupport: true };
                    store.profile.setUser(user);
                    history.push('/support/users');
                }
            }).catch((error) => {
                const { message } = error.data;
                console.log(message);
            });
    }

    useEffect(() => {
        const login = cookies.get('login');
        const sessionId = cookies.get('sessionId');

        if (login) {
            cookies.remove('login');
        }
        if (sessionId) {
            cookies.remove('sessionId');
        }

        if (login && sessionId) {
            supportAdmin(login, sessionId);
        }
    });

    return (<Preloader/>);
};

export default inject('store')(observer(SupportLoginPage));
